// About page translations
const aboutTranslations = {
  en: {
    hero: {
      eyebrow: "about / thewhizkind",
      title: "know no caution",
      summary: "thewhizkind is an independent creative and technology team based in Frankfurt am Main, with roots in New Delhi. We bring together design, technology and business to make things that are thoughtful, useful and worth noticing.",
      principlesLink: "our principles"
    },
    cards: {
      whatWeMake: {
        title: "what we make",
        content: "<strong>ideas made real.</strong> brands, websites, graphic design, digital experiences, ai, automation — and whatever the idea needs. see our <link-services>full range of services</link-services> or browse <link-gallery>selected visual work</link-gallery>."
      },
      howWeWork: {
        title: "how we work",
        content: "<strong>curious by default.</strong> we ask questions, experiment, make, break, rethink, and make things better."
      },
      motto: {
        title: "our motto",
        content: "<strong>know no caution.</strong> not recklessness. just the curiosity to try, learn, question, and see what happens."
      }
    },
    divider: "Since 2023",
    founder: {
      media: {
        portraitCaption: "portrait / frankfurt"
      },
      facts: {
        languages: "languages",
        languagesValue: "de · en · hi",
        education: "education",
        educationValue: "m.sc. accounting, finance & controlling",
        based: "based",
        basedValue: "frankfurt am main",
        pronouns: "pronouns",
        pronounsValue: "he/him/er/ihn"
      },
      copy: {
        label: "leading the collective",
        name: "Prayrit Singh",
        role: "co-founder · 27 · frankfurt am main",
        email: "prayrit@thewhizkind.com",
        profile: [
          "leads thewhizkind",
          "makes things",
          "breaks things",
          "makes them better",
          "creative direction",
          "technology",
          "ideas",
          "new delhi born",
          "frankfurt based",
          "between cultures",
          "finance",
          "curiosity",
          "always learning",
          "probably thinking about something",
          "asks too many questions",
          "night owl",
          "runs sometimes",
          "takes pictures",
          "looks at the stars",
          "jedi in training",
          "may the force be with you"
        ]
      }
    },
    footnote: {
      since: "Since 2023",
      practiceAreas: ["Design", "Technology", "Storytelling"]
    }
  },
  de: {
    hero: {
      eyebrow: "über uns / thewhizkind",
      title: "know no caution",
      summary: "thewhizkind ist ein unabhängiges kreativ- und technologieteam mit sitz in frankfurt am main und wurzeln in neu-delhi. wir verbinden design, technologie und business, um dinge zu schaffen, die durchdacht, nützlich und beachtenswert sind.",
      principlesLink: "unsere prinzipien"
    },
    cards: {
      whatWeMake: {
        title: "was wir erschaffen",
        content: "<strong>ideen verwirklichen.</strong> marken, websites, grafikdesign, digitale formate, ki, automatisierung — und was aus der idee sonst noch hervorgeht. sieh dir unser <link-services>gesamtes leistungsspektrum</link-services> an oder stöbere in unseren realisierten <link-gallery>grafikprojekten</link-gallery>."
      },
      howWeWork: {
        title: "wie wir arbeiten",
        content: "<strong>von natur aus neugierig.</strong> wir stellen fragen, experimentieren, gestalten, probieren aus, überdenken und verbessern dinge."
      },
      motto: {
        title: "unser motto",
        content: "<strong>know no caution.</strong> nicht rücksichtslos. nur die neugier treibt uns, dinge auszuprobieren, zu erlernen, zu hinterfragen und zu sehen, was passiert."
      }
    },
    divider: "seit 2023",
    founder: {
      media: {
        portraitCaption: "porträt / frankfurt"
      },
      facts: {
        languages: "sprachen",
        languagesValue: "de · en · hi",
        education: "ausbildung",
        educationValue: "m.sc. rechnungswesen, finanzen & controlling",
        based: "standort",
        basedValue: "frankfurt am main",
        pronouns: "pronomen",
        pronounsValue: "er/ihn"
      },
      copy: {
        label: "leiter des kollektivs",
        name: "Prayrit Singh",
        role: "mitgründer · 27 · frankfurt am main",
        email: "prayrit@thewhizkind.com",
        profile: [
          "leitet thewhizkind",
          "gestaltet dinge",
          "wirft dinge über den haufen",
          "verbessert sie",
          "kreative leitung",
          "technologie",
          "ideen",
          "in neu-delhi geboren",
          "in frankfurt ansässig",
          "zwischen den kulturen",
          "finanzen",
          "neugier",
          "lernt immer dazu",
          "denkt wahrscheinlich über etwas nach",
          "stellt zu viele fragen",
          "nachteule",
          "läuft ab und zu",
          "macht fotos",
          "schaut in die sterne",
          "jedi in der ausbildung",
          "möge die macht mit dir sein"
        ]
      }
    },
    footnote: {
      since: "seit 2023",
      practiceAreas: ["design", "technologie", "storytelling"]
    }
  }
};

export default aboutTranslations;